export default __webpack_public_path__ + "static/media/img4.5767d9cb.jpg";